<template>
  <div
    v-if="shouldShow"
    class="absolute top-2 right-0 z-up"
  >
    <template v-if="text">
      <div
        class="text-[13px] px-2.5 py-1 rounded-tl-lg rounded-bl-lg font-semibold text-white"
        :style="`background-color: ${bgColor || 'var(--blue-6)'};`"
      >
        {{ isPersonalUser ? $t('common.selected') : text }}
      </div>
    </template>
    <!-- <div
      v-else-if="auditStatus == AUDIT_STATUS.FAILED"
      class="text-[13px] px-2.5 py-1 rounded-tl-lg rounded-bl-lg font-semibold bg-red-6 text-white"
    >
      {{ isPersonalUser ? $t('common.selected') : $t('common.rejected_audit') }}
    </div> -->
    <div
      v-else-if="auditStatus == AUDIT_STATUS.PASSED"
      class="text-[13px] px-2.5 py-1 rounded-tl-lg rounded-bl-lg font-semibold bg-green-6 text-white"
    >
      {{ $t('common.selected') }}
    </div>
    <!-- <div
      v-else-if="auditStatus == AUDIT_STATUS.AUDITING"
      class="text-[13px] px-2.5 py-1 rounded-tl-lg rounded-bl-lg font-semibold bg-blue-6 text-white"
    >
      {{ isPersonalUser ? $t('common.selected') : $t('common.under_review') }}
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { AUDIT_STATUS } from '@/api/type'
import { usePermissionStore } from '@/stores/permission-store'
const permissionStore = usePermissionStore()
const isPersonalUser = computed(() => permissionStore.isPersonalUser)

type Props = {
  auditStatus?: number
  text?: string
  bgColor?: string
}

const props = defineProps<Props>()
const { t } = useI18n()

const shouldShow = computed(() => {
  return props.text
    || props.auditStatus === AUDIT_STATUS.FAILED
    || props.auditStatus === AUDIT_STATUS.PASSED
    || props.auditStatus === AUDIT_STATUS.AUDITING
})
</script>
